// extracted by mini-css-extract-plugin
export var cardHeader = "_s8-0";
export var reorderHandle = "_s8-3";
export var titleArea = "_s8-1";
export var titleAreaWithHandle = "_s8-2";